import { lazily } from 'react-lazily'

import { Centered } from 'layout'

/**
 * password recovery
 */
const { NewUserRegistration } = lazily(() =>
  import('pages/new-user-registration')
)

const LAYOUTS = {
  centered: Centered,
}

const newUserRegistrationRoutes = [
  {
    name: 'new-bouser-registration',
    path: 'activacion-de-cuenta',
    element: NewUserRegistration,
  },
]

export default newUserRegistrationRoutes
